import { render, staticRenderFns } from "./PanelDeControl.vue?vue&type=template&id=292cc210&"
import script from "./PanelDeControl.vue?vue&type=script&lang=js&"
export * from "./PanelDeControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports